/**
 * api.js — HTTP client + auth token helper.
 *
 * Token storage: localStorage (key 'mcb_token').
 *
 * NOTE on the security tradeoff:
 *   The recommended pattern for SPAs is httpOnly + Secure cookies, immune to
 *   XSS token theft. We tested it and the Cloudflare ingress in front of this
 *   environment intercepts CORS preflight requests with `Access-Control-Allow-Origin: *`,
 *   which browsers reject when `credentials: 'include'` is set — making cookies
 *   unusable across the frontend/backend subdomains. We therefore use a Bearer
 *   token in localStorage with these mitigations:
 *     - Strict CSP meta tag in public/index.html (limits XSS attack surface)
 *     - Short access-token lifetime (1h) — see backend core/security.py
 *     - All user-generated text rendered by React (auto-escaped — no dangerouslySetInnerHTML)
 *     - Rate-limited login + bcrypt + email enumeration kept minimal
 *   When backend & frontend land on the same origin (production single-domain),
 *   we should switch to httpOnly cookies — see core/security.py set_auth_cookies.
 */
import axios from "axios";

// En production (custom domain), front et back sont sur la même origin → on utilise
// l'origin du navigateur. En preview ou dev, on utilise REACT_APP_BACKEND_URL.
const BACKEND_URL =
  (typeof window !== "undefined" && window.location.hostname.endsWith("capsulepatrimoine.com"))
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "mcb_token";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setAuthToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur s'est produite. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function euro(n) {
  const v = Number(n || 0);
  return v.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 });
}
